import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
} from "@mui/material";
import { MainContent } from "IF/interfaceType";
import DashboardAreaStatus from "./DashboardAreaStatus";
import { memo, useEffect, useState } from "react";
import { MdBattery0Bar } from "react-icons/md";
import { useThemeMode } from "Contexts/ThemeContext";

export const DashboardPanel = memo(
  ({ panel, minusHeight }: { panel: MainContent; minusHeight?: number }) => {
    // テーブルの高さ設定
    const [tableBodyHeight, setTableBodyHeight] = useState(600);
    const hi = minusHeight ? minusHeight : 0;

    // ダークモード
    const { mode } = useThemeMode();
    const theme = useTheme();

    useEffect(() => {
      const updateHeight = () => {
        const windowHeight = window.innerHeight;
        const calculatedHeight = windowHeight - (352 + hi);
        setTableBodyHeight(calculatedHeight);
      };

      // 初期表示時とリサイズ時に高さを計算
      updateHeight();
      window.addEventListener("resize", updateHeight);

      // クリーンアップ
      return () => {
        window.removeEventListener("resize", updateHeight);
      };
    }, [hi]);

    // // ここを追加
    // useEffect(() => {
    //   console.log("=== DashboardPanel debug ===");
    //   console.log("panel.name =", panel.name);
    //   console.log("panel.serialNo =", panel.serialNo);

    //   panel.dashboardDataList.forEach((worker) => {
    //     console.log(
    //       "tagId =",
    //       worker.tagId,
    //       Array.from(worker.tagId).map((c) => c.charCodeAt(0))
    //     );
    //   });
    // }, [panel]);


    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "8px",
          gap: 1,
        }}
      >
        {/* PC用 */}
        <DashboardAreaStatus panel={panel} />
        <TableContainer
          component={Paper}
          sx={{
            maxHeight: tableBodyHeight,
            overflowY: "auto",
            backgroundColor: theme.palette.custom.row,
          }}
        >
          <Table>
            <TableBody
              sx={{
                flexGrow: 1,
                display: "block",
              }}
            >
              {panel.dashboardDataList.map((worker, index) => (
                <TableRow key={worker.tagId} sx={{ display: "flex" }}>
                  <TableCell
                    sx={{
                      flexGrow: 1,
                      fontSize: "15px",
                      fontWeight: index < panel.dangerNum ? "bold" : "normal",
                      color:
                        index < panel.dangerNum
                          ? "red"
                          : mode === "dark"
                            ? "#ffffff"
                            : "#000000",
                      borderBottom: "1px dashed grey",
                    }}
                  >
                    {worker.tagId} : {worker.name}
                  </TableCell>
                  {worker.battery === "01" && (
                    <TableCell
                      sx={{
                        display: "inline-flex",
                        textAlign: "center",
                        fontSize: "15px",
                        color: mode === "dark" ? "white" : "green",
                        borderBottom: "1px dashed grey",
                      }}
                    >
                      <Stack
                        direction="row"
                        spacing={0}
                        alignItems="center"
                        justifyContent="center"
                        sx={{
                          fontSize: "14px",
                          backgroundColor: "rgba(144, 238, 144, 0.3)",
                          padding: "2px",
                          borderRadius: "4px",
                        }}
                      >
                        <span>！電池交換！</span>
                        <MdBattery0Bar style={{ fontSize: "1.2em" }} />
                      </Stack>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
);

export default DashboardPanel;
